export default "__VITE_ASSET__h7QwkCv1__";